import type { RAGStatus } from '../../types';

const STATUS_CONFIG = {
  red: { bg: 'bg-app-critical', label: 'Not started' },
  amber: { bg: 'bg-app-warning', label: 'In progress' },
  green: { bg: 'bg-app-positive', label: 'Complete' },
};

export default function RAGIndicator({ status, showLabel = false }: { status: RAGStatus; showLabel?: boolean }) {
  const config = STATUS_CONFIG[status];
  return (
    <div className="flex items-center gap-2">
      <span className={`h-2.5 w-2.5 ${config.bg}`} aria-hidden="true" />
      {showLabel && <span className="text-xs text-app-muted">{config.label}</span>}
    </div>
  );
}
